import {ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {FormGroup, FormBuilder, Validators} from '@angular/forms'
import {Router} from '@angular/router'

import {AuthService} from '@app/core/services/rest-api'
import {finalize} from 'rxjs/operators'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup
  loading = false
  hasBeenRequested = false

  constructor(
    private authSvc: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.forgotForm = this.fb.group({
      email: this.fb.control(null, Validators.required),
    })
  }

  submit() {
    const value = this.forgotForm.value
    this.loading = true

    this.authSvc
      .postPasswordReset(value.email)
      .pipe(
        finalize(() => {
          this.hasBeenRequested = true
          this.loading = false
          // Zoneless: schedule CD so the "request sent" confirmation and the
          // spinner state actually render after the async request settles.
          this.cdr.markForCheck()
        }),
      )
      .subscribe(
        (result) => {
          // no longer automatically redirect to this page
          // this.router.navigate(['login','reset'], {queryParams: { src: 'forgot' }});
        },
        (err) => {
          if (err.error) {
            // should no longer trow errors - always 200 unless out of service?
          } else if (err.status !== 400) {
            let errMsg = 'An error occurred'
            errMsg =
              'The MyPayter Portal is currently unavailable. Please try again later or contact your account manager.'
            this.forgotForm.setErrors({global: errMsg})
          }
        },
      )
  }

  showFieldInvalid(name: string) {
    const field = this.forgotForm.get(name)
    return field.touched && field.invalid
  }

  unsetRequestedState() {
    this.hasBeenRequested = false
  }
}
